import StorefrontIcon from "@mui/icons-material/Storefront";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import { Box, Tooltip } from "@mui/material";
import { MooneIcon } from "Components/Shared/Icons/MooneIcon";
import type { AccessRoleCode } from "Models/AccessRoleCodes";
import { Resources, useResource } from "Translations/Resources";

const ROLES_RESOURCES = Resources.Chat.Roles;

type BadgeConfig = {
  icon: "storefront" | "verified" | "logo";
  bgcolor: string;
  labelKey: keyof typeof ROLES_RESOURCES;
};

const roleBadgeConfig: Partial<Record<AccessRoleCode, BadgeConfig>> = {
  Merchant: {
    icon: "storefront",
    bgcolor: "primary.main",
    labelKey: "Merchant",
  },
  Hunter: { icon: "verified", bgcolor: "success.main", labelKey: "Hunter" },
  HunterPlus: {
    icon: "verified",
    bgcolor: "success.main",
    labelKey: "HunterPlus",
  },
  Admin: { icon: "logo", bgcolor: "primary.main", labelKey: "Admin" },
  CustomerOnboarding: {
    icon: "logo",
    bgcolor: "primary.main",
    labelKey: "CustomerOnboarding",
  },
};

type Props = {
  accessRole: AccessRoleCode | undefined;
  avatarSize: number;
};

export const ChatRoleBadge = ({ accessRole, avatarSize }: Props) => {
  const { t } = useResource();
  const config = accessRole ? roleBadgeConfig[accessRole] : undefined;

  if (!config) {
    return null;
  }

  const badgeSize = Math.round(avatarSize * 0.4);
  const iconSize = Math.round(badgeSize * 0.65);

  return (
    <Tooltip title={t(ROLES_RESOURCES[config.labelKey])} arrow>
      <Box
        position="absolute"
        top={-2}
        right={-2}
        width={badgeSize}
        height={badgeSize}
        borderRadius="50%"
        bgcolor={config.bgcolor}
        border="1px solid"
        borderColor="background.paper"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        {config.icon === "storefront" && (
          <StorefrontIcon sx={{ fontSize: iconSize, color: "common.white" }} />
        )}
        {config.icon === "verified" && (
          <VerifiedUserIcon
            sx={{ fontSize: iconSize, color: "common.white" }}
          />
        )}
        {config.icon === "logo" && (
          <MooneIcon sx={{ fontSize: iconSize, color: "common.white" }} />
        )}
      </Box>
    </Tooltip>
  );
};
